import { NmsWizardStepModel } from "@nms-angular-toolkit/nms-wizard";
import { CircuitChangesCallbacks, CircuitChangeToBeApplied } from "../../../dwdm-circuit.model";

/**
 * Representa os dados de um equipamento intermediário DWDM
 */
export interface IntermediateDevice {
    resourceId: number;
    name: string;
    hostname?: string;
    serialNumber?: string;
    firmware?: string;
    locationId?: number;
    location?: string;
    lastUpdate?: string;
    status?: string;
}

/**
 * Representa o modelo do step Intermediates do DwdmCircuitWizard.
 */
export class IntermediatesStepModel extends NmsWizardStepModel {
    devices: IntermediateDevice[] = [];
    useIntermediateDevices: boolean = false;
}

/**
 * Modelo que representa os equipamentos intermediários que serão utilizados na validação do circuito DWDM.
 */
export interface IntermediateDevicesValidatorData {
    aEndResourceId: number;
    zEndResourceId: number;
    resourceIds: Array<number>;
}

/**
 * Define as possíveis alterações que o usuário pode fazer no passo de Intermediários.
 */
export type IntermediatesChanges =
    | "addIntermediate"
    | "removeIntermediate"
    | "removeAllIntermediate"
    | "changeUseIntermediate";

/**
 * Tipo que define uma mudança que o usuário realizou no passo de Intermediários.
 *
 * Contém o nome da alteração e os valores necessários para
 * realizar a alteração no momento apropriado.
 */
export type IntermediatesChangesToBeApplied = CircuitChangeToBeApplied<IntermediatesChanges>;

/**
 * Define as ações que devem ser realizadas para aplicar cada mudança possível no passo de Intermediários.
 */
export type IntermediatesChangesCallbacks = CircuitChangesCallbacks<IntermediatesChanges>;
